import { render, staticRenderFns } from "./AsignarProfesionales.vue?vue&type=template&id=638f8cd6&scoped=true&"
import script from "./AsignarProfesionales.vue?vue&type=script&lang=js&"
export * from "./AsignarProfesionales.vue?vue&type=script&lang=js&"
import style0 from "./AsignarProfesionales.vue?vue&type=style&index=0&id=638f8cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638f8cd6",
  null
  
)

export default component.exports